import React from "react";
import { Input, Space } from "antd";
import { Game } from "../../../../services/gameQuiz/gameQuiz.types";
import ImageUploadInput from "../ImageUploadInput";
import TtsAudioControls from "../TtsAudioControls";

type TextInputAiGame = Extract<Game, { type: "text_input_ai" }>;

type Props = {
  game: TextInputAiGame;
  onChange: (game: TextInputAiGame) => void;
  generateAudio?: (text: string) => Promise<string>;
};

const TextInputAiEditor: React.FC<Props> = ({
  game,
  onChange,
  generateAudio,
}) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <div>
        <label>Pregunta</label>
        <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
          <Input.TextArea
            value={game.question}
            onChange={(e) => onChange({ ...game, question: e.target.value })}
            rows={2}
            style={{ flex: 1 }}
          />
          <TtsAudioControls
            text={game.question}
            audioUrl={game.questionAudio}
            onAudioChange={(url) => onChange({ ...game, questionAudio: url })}
            generateAudio={generateAudio}
          />
        </div>
      </div>

      <div>
        <label>Imagen (opcional)</label>
        <ImageUploadInput
          value={game.image}
          onChange={(url) => onChange({ ...game, image: url })}
        />
      </div>

      <div
        style={{
          padding: 12,
          border: "1px solid var(--bo-card-border)",
          borderRadius: 6,
        }}
      >
        <label style={{ fontWeight: 600 }}>Opciones y Respuestas</label>

        <div style={{ marginTop: 12 }}>
          <label>Asignatura</label>
          <Input
            value={game.subject}
            onChange={(e) => onChange({ ...game, subject: e.target.value })}
            placeholder="Ej. Ciencias naturales"
            style={{ marginTop: 4 }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>Grado</label>
          <Input
            value={game.grade}
            onChange={(e) => onChange({ ...game, grade: e.target.value })}
            placeholder="Ej. 5o"
            style={{ marginTop: 4 }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>Respuesta modelo</label>
          <Input.TextArea
            value={game.modelAnswer}
            onChange={(e) => onChange({ ...game, modelAnswer: e.target.value })}
            rows={3}
            placeholder="La respuesta esperada que cubre las ideas clave"
            style={{ marginTop: 4 }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>Ideas clave</label>
          <Input.TextArea
            value={game.keyIdeas}
            onChange={(e) => onChange({ ...game, keyIdeas: e.target.value })}
            rows={3}
            placeholder="Las ideas que la respuesta del alumno debe cubrir para ganar el punto"
            style={{ marginTop: 4 }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>Palabras clave (opcional)</label>
          <Input.TextArea
            value={game.keywords}
            onChange={(e) => onChange({ ...game, keywords: e.target.value })}
            rows={2}
            placeholder="Referencia adicional para la evaluación (opcional)"
            style={{ marginTop: 4 }}
          />
        </div>
      </div>
    </Space>
  );
};

export default TextInputAiEditor;
